import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, Select, TextArea } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section4({
  data,
  errors,
  onChange
}: SectionProps) {
  return <div className="space-y-6" data-id="element-77">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-78">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-79">
          <span className="text-dorado mr-2" data-id="element-80">Sección 04 ·</span>
          Hábitos de Alimentación
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-81">
          Conozcamos cómo nutres tu cuerpo actualmente.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-82">
        <FormField label="¿Cuántas comidas haces al día?" name="comidas" error={errors.comidas} required data-id="element-83">
          <Select id="comidas" value={data.comidas} onChange={e => onChange('comidas', e.target.value)} error={!!errors.comidas} data-id="element-84">
            <option value="" data-id="element-85">Selecciona...</option>
            <option value="1-2" data-id="element-86">1 a 2 comidas</option>
            <option value="3" data-id="element-87">3 comidas</option>
            <option value="4" data-id="element-88">4 comidas</option>
            <option value="5+" data-id="element-89">5 o más comidas (incluyendo snacks)</option>
          </Select>
        </FormField>

        <FormField label="Consumo de agua diario" name="agua" error={errors.agua} required data-id="element-90">
          <Select id="agua" value={data.agua} onChange={e => onChange('agua', e.target.value)} error={!!errors.agua} data-id="element-91">
            <option value="" data-id="element-92">Selecciona...</option>
            <option value="<1" data-id="element-93">Menos de 1 litro</option>
            <option value="1-2" data-id="element-94">Entre 1 y 2 litros</option>
            <option value="2-3" data-id="element-95">Entre 2 y 3 litros</option>
            <option value="3+" data-id="element-96">Más de 3 litros</option>
          </Select>
        </FormField>
      </div>

      <FormField label="¿Con qué frecuencia consumes alimentos ultraprocesados, dulces o comida rápida?" name="procesada" error={errors.procesada} required data-id="element-97">
        <div className="space-y-3 mt-2" data-id="element-98">
          {['Nunca o casi nunca', 'A veces (1-2 veces por semana)', 'Frecuentemente (3-4 veces por semana)', 'A diario'].map(option => <label key={option} className="flex items-center space-x-3 p-3 border-2 border-plateado rounded-xl cursor-pointer hover:border-dorado transition-colors bg-white" data-id="element-99">
              <input type="radio" name="procesada" value={option} checked={data.procesada === option} onChange={e => onChange('procesada', e.target.value)} className="w-5 h-5 text-dorado focus:ring-dorado" data-id="element-100" />
              <span className="text-texto-oscuro" data-id="element-101">{option}</span>
            </label>)}
        </div>
      </FormField>

      <FormField label="Menciona los 5 alimentos que más consumes en tu día a día" name="alimentos" error={errors.alimentos} required data-id="element-102">
        <TextArea id="alimentos" value={data.alimentos} onChange={e => onChange('alimentos', e.target.value)} error={!!errors.alimentos} placeholder="Ej. Pan, pollo, arroz, café, manzanas..." className="min-h-[100px]" data-id="element-103" />
      </FormField>

      <FormField label="¿Tienes alguna alergia, intolerancia o restricción alimentaria?" name="restricciones" error={errors.restricciones} description="(Opcional) Ej. Intolerancia a la lactosa, celiaquía, vegano/a, etc." data-id="element-104">
        <TextArea id="restricciones" value={data.restricciones} onChange={e => onChange('restricciones', e.target.value)} error={!!errors.restricciones} placeholder="Detalla aquí si aplica..." className="min-h-[100px]" data-id="element-105" />
      </FormField>
    </div>;
}